import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';

export const AdditionalSupportProductivityQualityFAQSet: React.FunctionComponent = () => {
  return (
    <Expander titleText="What time frame are my feedbacks for?">
      <Text>
        PAK2.0 displays Safety, Behavioral and Time feedbacks that you have received over the past 365 days. Please allow 24 hours for yesterday's data to be updated.
      </Text>
    </Expander>
  );
}